import { AccredibleReadMoreComponent } from '@accredible-frontend-v2/new-components/ui-common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { BlogArticleComponentModule } from '../blog-article/blog-article.component.module';
import { FeaturedVideoComponentModule } from '../featured-video/featured-video.component.module';

@Component({
  standalone: true,
  selector: 'cf-side-content',
  templateUrl: `./side-content.component.html`,
  styleUrls: ['./side-content.component.scss'],
  imports: [
    TranslocoModule,
    BlogArticleComponentModule,
    FeaturedVideoComponentModule,
    AccredibleReadMoreComponent,
  ],
})
export class SideContentComponent {}
